import { Menu, MenuProps } from 'react-admin';
import {
  Dashboard as DashboardIcon,
  MonetizationOn,
  Category,
  AccountBalance,
  Link as LinkIcon,
  Language,
  Business,
  AccountBalanceWallet,
  TrendingUp,
  Description,
  Label,
  SwapHoriz,
  Code,
  Update,
} from '@mui/icons-material';

export const CustomMenu = (props: MenuProps) => (
  <Menu {...props}>
    <Menu.DashboardItem />
    <Menu.Item to="/coins" primaryText="Coins" leftIcon={<MonetizationOn />} />
    <Menu.Item to="/categories" primaryText="Categories" leftIcon={<Category />} />
    <Menu.Item to="/verified_exchanges" primaryText="Verified Exchanges" leftIcon={<SwapHoriz />} />
    <Menu.Item to="/platforms" primaryText="Platforms" leftIcon={<LinkIcon />} />
    <Menu.Item to="/chains" primaryText="Chains" leftIcon={<Language />} />
    <Menu.Item to="/funds" primaryText="Funds" leftIcon={<TrendingUp />} />
    <Menu.Item to="/treasury_entities" primaryText="Treasury Entities" leftIcon={<Business />} />
    <Menu.Item to="/treasuries" primaryText="Treasuries" leftIcon={<AccountBalanceWallet />} />
    <Menu.Item to="/languages" primaryText="Languages" leftIcon={<Language />} />
    <Menu.Item to="/reports" primaryText="Reports" leftIcon={<Description />} />
    <Menu.Item to="/address_labels" primaryText="Address Labels" leftIcon={<Label />} />
    <Menu.Item to="/evm_method_labels" primaryText="EVM Method Labels" leftIcon={<Code />} />
    <Menu.Item to="/update_states" primaryText="Update States" leftIcon={<Update />} />
  </Menu>
);
